import KLoading from '@kso/ui/lib/Loading';
import '@kso/ui/lib/Loading/style.css';
import KDButton from '@kdocs/kdesign-vue/lib/button';
import '@kdocs/kdesign-theme/default.css';
import '@kdocs/kdesign-vue/lib/theme-chalk/base.css';
import '@kdocs/kdesign-vue/lib/theme-chalk/button.css';

var Button = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.useNewLayout ? _c('KDButton', {
      attrs: {
        "type": _vm.kdType,
        "danger": _vm.kdDanger,
        "loading": _vm.loading,
        "disabled": _vm.disabled
      },
      on: {
        "click": function click($event) {
          !_vm.disabled && _vm.$listeners && _vm.$listeners.click && _vm.$listeners.click();
        }
      }
    }, [_vm._t("default")], 2) : _c('button', {
      "class": ['k-button', "k-button--" + _vm.size, "k-button--" + _vm.type, {
        'k-button--disabled': _vm.disabled
      }],
      on: {
        "click": function click($event) {
          !_vm.disabled && _vm.$listeners && _vm.$listeners.click && _vm.$listeners.click();
        }
      }
    }, [_vm.loading ? _c('i', {
      staticClass: "is-loading"
    }, [_c('KLoading')], 1) : _vm._e(), _vm._v(" "), _vm.$slots["default"] ? _c('span', [_vm._t("default")], 2) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'KButton',
  components: {
    KLoading: KLoading,
    KDButton: KDButton
  },
  props: {
    size: {
      type: String,
      "default": 'm',
      validator: function validator(v) {
        return ['s', 'm', 'l'].indexOf(v) !== -1;
      }
    },
    type: {
      type: String,
      "default": 'normal',
      validator: function validator(v) {
        return ['normal', 'primary', 'danger'].indexOf(v) !== -1;
      }
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    loading: {
      type: Boolean,
      "default": false
    },
    useNewLayout: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    kdType: function kdType() {
      if (this.type === 'normal') {
        return 'secondary';
      } else if (this.type === 'danger') {
        return 'primary';
      }
      return this.type;
    },
    kdDanger: function kdDanger() {
      return this.type === 'danger';
    }
  }
};

Button.install = function (Vue) {
  Vue.component(Button.name, Button);
};

export { Button as default };
